import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, mergeProps as _mergeProps, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-17a37061"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["data-renderer-id"]
const _hoisted_2 = ["id", "value", "disabled", "autofocus", "placeholder", "data-id"]
const _hoisted_3 = ["id", "data-id"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "preview form-control",
  style: {"display":"none"}
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_FunctionSelector = _resolveComponent("FunctionSelector")!
  const _component_control_wrapper = _resolveComponent("control-wrapper")!

  return (_openBlock(), _createBlock(_component_control_wrapper, _mergeProps(_ctx.controlWrapper, {
    styles: _ctx.styles,
    isFocused: _ctx.isFocused,
    appliedOptions: _ctx.appliedOptions
  }), {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: "d-flex flex-column",
        "data-renderer-id": _ctx.RendererConfigurations.StringControlRenderer.name
      }, [
        _createElementVNode("div", {
          class: "input-div",
          onMouseenter: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.onMouseEnter && _ctx.onMouseEnter(...args))),
          onMouseleave: _cache[10] || (_cache[10] = ($event: any) => (_ctx.showCopy = false))
        }, [
          _createElementVNode("input", {
            ref: "inputField",
            id: _ctx.control.id + '-input',
            class: _normalizeClass([_ctx.styles.control.input]),
            value: _ctx.control.data,
            disabled: !_ctx.control.enabled,
            autofocus: _ctx.appliedOptions.focus,
            placeholder: _ctx.appliedOptions.placeholder,
            onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onChange && _ctx.onChange(...args))),
            onFocus: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isFocused = true)),
            onBlur: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isFocused = false)),
            style: {"display":"none !important"},
            "data-id": _ctx.control.id.replace('#/', '') + '-input'
          }, null, 42, _hoisted_2),
          (_ctx.showCopy)
            ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                key: 0,
                icon: _ctx.copied ? 'check' : 'copy',
                class: "copy-icon",
                onClick: _ctx.copyContainerContent
              }, null, 8, ["icon", "onClick"]))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            id: _ctx.control.id + '-div',
            class: _normalizeClass(["form-control root-div", {
            'required-border':
              (!_ctx.control.data || _ctx.control.data === '' || _ctx.control.data === '[]') &&
              _ctx.control.required,
            password: _ctx.control.schema.masked,
          }]),
            onFocusout: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.organizeNodes && _ctx.organizeNodes(...args))),
            onFocus: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.setActiveInjectionTarget && _ctx.setActiveInjectionTarget(...args))),
            onKeyup: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.organizeNodes && _ctx.organizeNodes(...args))),
            onKeydown: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.onKeyDown && _ctx.onKeyDown(...args))),
            onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.clickEvent && _ctx.clickEvent(...args))),
            contenteditable: "true",
            onBlur: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.onBlur && _ctx.onBlur(...args))),
            ref: "div",
            spellcheck: "false",
            style: {"white-space":"pre-wrap","display":"inline-block"},
            "data-id": _ctx.control.id.replace('#/', '') + '-div'
          }, null, 42, _hoisted_3),
          _hoisted_4
        ], 32),
        _createVNode(_component_FunctionSelector, {
          "output-list": _ctx.outputList,
          mode: "input",
          "old-path": _ctx.oldPath,
          "id-prefix": _ctx.control.id,
          visible: _ctx.visible,
          expressions: _ctx.expressions,
          "show-other-inputs": true,
          showMeta: true,
          onAddMetaoutput: _ctx.addMetaoutput,
          onAddOutput: _ctx.addOutput,
          onAddUserVariable: _ctx.addUserVariable,
          "user-defined-variables": _ctx.userDefinedVariables,
          "system-variables": _ctx.systemVariables,
          onAddFunction: _ctx.addFunction,
          "metaoutput-list": _ctx.metaoutputList,
          onAddSystemVariable: _ctx.addSystemVariable,
          "show-exp-info": _ctx.expressionInfoEnabled && _ctx.showModal,
          "function-name": _ctx.clickedFunctionName,
          "selected-variables": _ctx.selectedVariables
        }, null, 8, ["output-list", "old-path", "id-prefix", "visible", "expressions", "onAddMetaoutput", "onAddOutput", "onAddUserVariable", "user-defined-variables", "system-variables", "onAddFunction", "metaoutput-list", "onAddSystemVariable", "show-exp-info", "function-name", "selected-variables"])
      ], 8, _hoisted_1)
    ]),
    _: 1
  }, 16, ["styles", "isFocused", "appliedOptions"]))
}